"use client";

import { useCallback, useEffect, useRef, useState } from "react";

/**
 * How long a re-sliced grid declares its wait in skeleton (prototype `pulsarCarga`, CARD-24).
 * Changing department or category, or applying a search, redoes the attributes and the grid:
 * the change is declared, and the skeleton leaves on its own.
 */
export const SKELETON_PULSE_MS = 420;

/** `[isPulsing, pulse]`: `pulse()` shows the skeleton for `SKELETON_PULSE_MS`, restarting it. */
export function useSkeletonPulse(): readonly [boolean, () => void] {
  const [isPulsing, setIsPulsing] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(
    () => () => {
      if (timer.current !== null) clearTimeout(timer.current);
    },
    [],
  );

  const pulse = useCallback(() => {
    if (timer.current !== null) clearTimeout(timer.current);
    setIsPulsing(true);
    timer.current = setTimeout(() => {
      timer.current = null;
      setIsPulsing(false);
    }, SKELETON_PULSE_MS);
  }, []);

  return [isPulsing, pulse] as const;
}
